import { Box, Flex, Text } from '@chakra-ui/react';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react';

interface BlogTagFilterProps {
  tags: string[];
  activeTag?: string;
  onTagChange: (tag: string | undefined) => void;
}

export const BlogTagFilter = ({ tags, activeTag, onTagChange }: BlogTagFilterProps) => {
  const { _ } = useLingui();

  if (tags.length === 0) return null;

  return (
    <Flex gap={2} flexWrap="wrap" mb={8}>
      <TagPill
        label={_(msg({ id: 'blog.filter.all', message: 'All' }))}
        isActive={!activeTag}
        onClick={() => onTagChange(undefined)}
      />
      {tags.map((tag) => (
        <TagPill
          key={tag}
          label={tag}
          isActive={activeTag === tag}
          onClick={() => onTagChange(activeTag === tag ? undefined : tag)}
        />
      ))}
    </Flex>
  );
};

const TagPill = ({
  label,
  isActive,
  onClick,
}: {
  label: string;
  isActive: boolean;
  onClick: () => void;
}) => (
  <Box
    as="button"
    px={4}
    py={1.5}
    borderRadius="full"
    textStyle="title"
    cursor="pointer"
    transition="all 150ms"
    bg={isActive ? 'purple.400' : 'whiteAlpha.100'}
    color={isActive ? 'white' : 'whiteAlpha.700'}
    _hover={{
      bg: isActive ? 'purple.500' : 'whiteAlpha.200',
      color: 'white',
    }}
    css={{
      '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    }}
    onClick={onClick}
  >
    <Text>{label}</Text>
  </Box>
);
